
import React from 'react';
import { GamePlanner2View } from '@/components/game-planner2/GamePlanner2View';

const GamePlanner2: React.FC = () => {
  return <GamePlanner2View />;
};

export default GamePlanner2;
